import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-office-type-edit',
  templateUrl: './admin-office-type-edit.component.html'
})
export class AdminOfficeTypeEditComponent implements OnChanges, OnInit {
  @Input() formdata;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: ['', ''],
      abbreviation: ['', ''],
      name: ['', ''],
      sort: ['', '']
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
    }
  }

  saveOfficeType() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }

}
